export default __webpack_public_path__ + "static/media/RO.1e4b89db.svg";